import type {
  FindPaymentsRequestFilter,
  FindPaymentsRequestSort,
} from '~domains/transactions/entities/payment';

import type { DataTableSorting } from '~shared/ui/data-table';

import { endOfDay, startOfDay } from 'date-fns';

import { ColumnId } from './columns';

import type { PaymentsFiltersValue } from '../model/payments-filters';

type SortableColumn = ColumnId.SETTLED_AMOUNT;

const COLUMN_TO_SORT_KEY: Record<
  SortableColumn,
  FindPaymentsRequestSort['key']
> = {
  [ColumnId.SETTLED_AMOUNT]: 'settledAmount',
};

export function sortToParams(
  sorting: DataTableSorting | undefined
): FindPaymentsRequestSort | undefined {
  if (!sorting) return undefined;

  const key = COLUMN_TO_SORT_KEY[sorting.id as SortableColumn];
  if (!key) return undefined;

  return { key, order: sorting.direction === 'asc' ? 'ASC' : 'DESC' };
}

export function filtersToParams({
  period,
  merchantIds,
  statuses,
}: PaymentsFiltersValue): FindPaymentsRequestFilter {
  const { startDate, endDate } = period ?? {};
  const dateTo = endDate ? new Date(endDate) : new Date();
  const dateFrom = startDate ? new Date(startDate) : new Date();

  return {
    dateTo: endOfDay(dateTo).toISOString(),
    dateFrom: startOfDay(dateFrom).toISOString(),
    merchantIds,
    paymentStatuses: statuses,
  };
}
